export default __webpack_public_path__ + "maps-examples-custom-callout-960-c766e2ae8c82f31b9e138c1bf5e2bcbb.webp";